const baseScheme = process.env.NEXT_PUBLIC_CAPACITOR_CALLBACK_SCHEME;
const capacitorEnv = process.env.NEXT_PUBLIC_CAPACITOR_ENV;

export const APP_AUTH_CALLBACK_SCHEME = baseScheme
  ? capacitorEnv === 'test'
    ? `${baseScheme}.test`
    : baseScheme
  : '';
export const APP_AUTH_CALLBACK_HOST = 'auth';
export const APP_AUTH_APP_LINK_PATH = '/auth/callback';
export const APP_AUTH_CUSTOM_SCHEME_PATH = '/callback';

const getAppLinkCallbackBaseUrl = (): string => {
  if (typeof window === 'undefined' || !window.location.host) {
    return '';
  }

  return `https://${window.location.host}${APP_AUTH_APP_LINK_PATH}`;
};

const getCustomSchemeCallbackBaseUrl = (): string => {
  if (!APP_AUTH_CALLBACK_SCHEME) {
    return '';
  }

  return `${APP_AUTH_CALLBACK_SCHEME}://${APP_AUTH_CALLBACK_HOST}${APP_AUTH_CUSTOM_SCHEME_PATH}`;
};

export const getAppAuthCallbackUrl = (
  searchParams?: URLSearchParams
): string => {
  const baseUrl =
    getAppLinkCallbackBaseUrl() || getCustomSchemeCallbackBaseUrl();

  if (!baseUrl) {
    return '';
  }

  if (!searchParams || searchParams.keys().next().done) {
    return baseUrl;
  }

  return `${baseUrl}?${searchParams.toString()}`;
};
